import { connect, ConnectedProps } from 'react-redux';
import { DATA_FETCHING_STATUS } from 'src/redux/data/constants';

import {
  selectors as emrMappingsSelectors,
  actions as emrMappingsActions,
} from 'src/redux/data/emrMappings';
import {
  selectors as siteGroupsSelectors,
  actions as siteGroupsActions,
} from 'src/redux/data/siteGroups';
import { RootState } from 'src/redux/store';
import { DATA_STRATEGY } from 'src/utils/constants';

const mapStateToProps = (state: RootState) => {
  const operatorTenantsList = emrMappingsSelectors.selectOperatorTenants(state);

  const facilitiesList = emrMappingsSelectors.selectFacilties(state);

  const facilityInitialDict = facilitiesList?.reduce((acc, curr) => {
    const linkedTenant = operatorTenantsList?.find(
      tenant => tenant.emrId === curr.id,
    );

    return {
      ...acc,
      [curr.id]: {
        tenantName: linkedTenant?.name,
        manualGroupIds: null,
        tenantId: linkedTenant ? linkedTenant.id : null,
        strategy: linkedTenant ? DATA_STRATEGY.LINKED : DATA_STRATEGY.SKIP,
      },
    };
  }, {});

  return {
    siteGroupsList: siteGroupsSelectors.getSiteGroups(state)?.data,
    operatorTenantsList: operatorTenantsList || [],
    facilitiesList: facilitiesList || [],
    facilityInitialDict: facilityInitialDict || {},
    isLoadingOperatorTenants:
      emrMappingsSelectors.isLoadingOperatorTenants(state),
    isLoadingFacilities: emrMappingsSelectors.isLoadingFacilities(state),
    isLoadingMappingFacilities:
      emrMappingsSelectors.selectMapFacilitiesStatus(state) ===
      DATA_FETCHING_STATUS.LOADING,
    isLoadingSyncFacility:
      emrMappingsSelectors.selectSyncFacilityStatus(state) ===
      DATA_FETCHING_STATUS.LOADING,
    isLoadingOnboardFacility:
      emrMappingsSelectors.selectOnboardFacilityStatus(state) ===
      DATA_FETCHING_STATUS.LOADING,
    isLoadingOnboardPatients:
      emrMappingsSelectors.selectOnboardPatientsStatus(state) ===
      DATA_FETCHING_STATUS.LOADING,
  };
};

const mapActionCreators = {
  getOperatorTenants: emrMappingsActions.getOperatorTenants,
  getFacilities: emrMappingsActions.getFacilities,
  getSiteGroups: siteGroupsActions.getSiteGroups,
  mapFacilities: emrMappingsActions.mapFacilities,
  syncFacility: emrMappingsActions.syncFacility,
  onboardFacility: emrMappingsActions.onboardFacility,
  onboardPatients: emrMappingsActions.onboardPatients,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
